import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// MODULES
import agents from './modules/agents'
import receivables from './modules/receivables'
import accounts from './modules/accounts'
import accountSettings from './modules/accountSettings'
import analytics from './modules/analytics'
import apps from './modules/apps'
import auth from './modules/auth'
import banks from './modules/banks'
import billers from './modules/billers'
import dashboards from './modules/dashboards'
import dataExports from './modules/exports'
import generals from './modules/generals'
import global from './modules/global'
import customers from './modules/customers'
import invoices from './modules/invoices'
import notifications from './modules/notifications'
import orders from './modules/orders'
import subscriptions from './modules/subscriptions'
import payments from './modules/payments'
import reminders from './modules/reminders'
import purchases from './modules/purchases'
import referrals from './modules/referrals'
import suppliers from './modules/suppliers'
import bulks from './modules/bulks'
import onboarding from './modules/onboarding'
import supportingDocuments from './modules/supporting-documents'
import ui from './modules/ui'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: true,
  modules: {
    agents,
    accounts,
    accountSettings,
    analytics,
    apps,
    auth,
    banks,
    billers,
    dashboards,
    exports: dataExports,
    generals,
    global,
    customers,
    invoices,
    notifications,
    orders,
    subscriptions,
    payments,
    reminders,
    purchases,
    receivables,
    referrals,
    suppliers,
    bulks,
    onboarding,
    supportingDocuments,
    ui
  },
  plugins: [
    createPersistedState({
      paths: ['auth', 'ui']
    })
  ]
})
